// Changing the Cart number on add to cart

const mainAddtoCart = document.querySelector('#add-to-cart-button-main')
const cartIconNumber = document.querySelector('[aria-label="Cart"] div')
const statusMessageAfterSubmit = document.querySelector('.product-status-message')

if(mainAddtoCart) {
  mainAddtoCart.addEventListener('click', () => {
    changeCartNumber()
  })
}

function changeCartNumber () {
  const prevNumber = Number(cartIconNumber.innerHTML)

  setTimeout(() => {
    if(statusMessageAfterSubmit.innerHTML == '') {
      cartIconNumber.innerHTML = prevNumber + 1
    }
  }, 2000)
}